export default {"src":"/_next/static/media/illustration-dog-bowl.6287002c.svg","height":90,"width":93};